export const teachersData = [
  {
    recordId: 1,
    teacher: {
      name: "Alice Johnson",
      id: 10001,
      department: "Finance",
    },
    studentCount: 25,
    status: "Active",
  },
  {
    recordId: 2,
    teacher: {
      name: "Robert Smith",
      id: 10002,
      department: "Engineer",
    },
    studentCount: 30,
    status: "Inactive",
  },
  {
    recordId: 3,
    teacher: {
      name: "Mary Williams",
      id: 10003,
      department: "Arts",
    },
    studentCount: 15,
    status: "Suspended",
  },
  {
    recordId: 4,
    teacher: {
      name: "James Brown",
      id: 10004,
      department: "Finance",
    },
    studentCount: 10,
    status: "Blocked",
  },
  {
    recordId: 5,
    teacher: {
      name: "Patricia Taylor",
      id: 10005,
      department: "Engineer",
    },
    studentCount: 20,
    status: "Active",
  },
  {
    recordId: 6,
    teacher: {
      name: "David Wilson",
      id: 10006,
      department: "Arts",
    },
    studentCount: 22,
    status: "Inactive",
  },
  {
    recordId: 7,
    teacher: {
      name: "Linda Garcia",
      id: 10007,
      department: "Finance",
    },
    studentCount: 18,
    status: "Active",
  },
  {
    recordId: 8,
    teacher: {
      name: "Michael Martinez",
      id: 10008,
      department: "Engineer",
    },
    studentCount: 27,
    status: "Suspended",
  },
  {
    recordId: 9,
    teacher: {
      name: "Elizabeth Lopez",
      id: 10009,
      department: "Arts",
    },
    studentCount: 35,
    status: "Blocked",
  },
  {
    recordId: 10,
    teacher: {
      name: "Charles Anderson",
      id: 10010,
      department: "Finance",
    },
    studentCount: 16,
    status: "Active",
  },
  {
    recordId: 11,
    teacher: {
      name: "Susan Thomas",
      id: 10011,
      department: "Engineer",
    },
    studentCount: 29,
    status: "Inactive",
  },
  {
    recordId: 12,
    teacher: {
      name: "Joseph Jackson",
      id: 10012,
      department: "Arts",
    },
    studentCount: 21,
    status: "Active",
  },
  {
    recordId: 13,
    teacher: {
      name: "Barbara White",
      id: 10013,
      department: "Finance",
    },
    studentCount: 11,
    status: "Suspended",
  },
  {
    recordId: 14,
    teacher: {
      name: "Daniel Harris",
      id: 10014,
      department: "Engineer",
    },
    studentCount: 34,
    status: "Blocked",
  },
  {
    recordId: 15,
    teacher: {
      name: "Lisa Clark",
      id: 10015,
      department: "Arts",
    },
    studentCount: 28,
    status: "Active",
  },
  {
    recordId: 16,
    teacher: {
      name: "Matthew Lewis",
      id: 10016,
      department: "Finance",
    },
    studentCount: 23,
    status: "Inactive",
  },
  {
    recordId: 17,
    teacher: {
      name: "Angela Robinson",
      id: 10017,
      department: "Engineer",
    },
    studentCount: 15,
    status: "Suspended",
  },
  {
    recordId: 18,
    teacher: {
      name: "Kevin Hall",
      id: 10018,
      department: "Arts",
    },
    studentCount: 17,
    status: "Blocked",
  },
  {
    recordId: 19,
    teacher: {
      name: "Jessica Young",
      id: 10019,
      department: "Finance",
    },
    studentCount: 19,
    status: "Active",
  },
  {
    recordId: 20,
    teacher: {
      name: "Joshua King",
      id: 10020,
      department: "Engineer",
    },
    studentCount: 26,
    status: "Inactive",
  },
  {
    recordId: 21,
    teacher: {
      name: "Karen Wright",
      id: 10021,
      department: "Arts",
    },
    studentCount: 31,
    status: "Active",
  },
  {
    recordId: 22,
    teacher: {
      name: "Brian Scott",
      id: 10022,
      department: "Finance",
    },
    studentCount: 12,
    status: "Suspended",
  },
  {
    recordId: 23,
    teacher: {
      name: "Nancy Green",
      id: 10023,
      department: "Engineer",
    },
    studentCount: 14,
    status: "Blocked",
  },
  {
    recordId: 24,
    teacher: {
      name: "David Adams",
      id: 10024,
      department: "Arts",
    },
    studentCount: 20,
    status: "Active",
  },
  {
    recordId: 25,
    teacher: {
      name: "Rebecca Nelson",
      id: 10025,
      department: "Finance",
    },
    studentCount: 24,
    status: "Inactive",
  },
  {
    recordId: 26,
    teacher: {
      name: "Charles Carter",
      id: 10026,
      department: "Engineer",
    },
    studentCount: 22,
    status: "Active",
  },
  {
    recordId: 27,
    teacher: {
      name: "Samantha Mitchell",
      id: 10027,
      department: "Arts",
    },
    studentCount: 10,
    status: "Suspended",
  },
  {
    recordId: 28,
    teacher: {
      name: "Timothy Perez",
      id: 10028,
      department: "Finance",
    },
    studentCount: 32,
    status: "Blocked",
  },
  {
    recordId: 29,
    teacher: {
      name: "Laura Roberts",
      id: 10029,
      department: "Engineer",
    },
    studentCount: 19,
    status: "Active",
  },
  {
    recordId: 30,
    teacher: {
      name: "Jonathan Turner",
      id: 10030,
      department: "Arts",
    },
    studentCount: 21,
    status: "Inactive",
  },
  {
    recordId: 31,
    teacher: {
      name: "Cynthia Phillips",
      id: 10031,
      department: "Finance",
    },
    studentCount: 26,
    status: "Active",
  },
  {
    recordId: 32,
    teacher: {
      name: "Ethan Campbell",
      id: 10032,
      department: "Engineer",
    },
    studentCount: 27,
    status: "Suspended",
  },
  {
    recordId: 33,
    teacher: {
      name: "Megan Parker",
      id: 10033,
      department: "Arts",
    },
    studentCount: 30,
    status: "Blocked",
  },
  {
    recordId: 34,
    teacher: {
      name: "Tyler Evans",
      id: 10034,
      department: "Finance",
    },
    studentCount: 18,
    status: "Active",
  },
  {
    recordId: 35,
    teacher: {
      name: "Brittany Edwards",
      id: 10035,
      department: "Engineer",
    },
    studentCount: 29,
    status: "Inactive",
  },
  {
    recordId: 36,
    teacher: {
      name: "Adam Collins",
      id: 10036,
      department: "Arts",
    },
    studentCount: 15,
    status: "Active",
  },
  
  // {
  //   recordId: 41,
  //   teacher: {
  //     name: "Angela Cooper",
  //     id: 10041,
  //     department: "Engineer",
  //   },
  //   studentCount: 30,
  //   status: "Active",
  // },
  // {
  //   recordId: 42,
  //   teacher: {
  //     name: "Anthony Reed",
  //     id: 10042,
  //     department: "Arts",
  //   },
  //   studentCount: 11,
  //   status: "Suspended",
  // },
  // {
  //   recordId: 43,
  //   teacher: {
  //     name: "Sophia Bailey",
  //     id: 10043,
  //     department: "Finance",
  //   },
  //   studentCount: 20,
  //   status: "Blocked",
  // },
  // {
  //   recordId: 44,
  //   teacher: {
  //     name: "Christopher Bell",
  //     id: 10044,
  //     department: "Engineer",
  //   },
  //   studentCount: 33,
  //   status: "Active",
  // },
  // {
  //   recordId: 45,
  //   teacher: {
  //     name: "Alice Walker",
  //     id: 10045,
  //     department: "Arts",
  //   },
  //   studentCount: 12,
  //   status: "Inactive",
  // },
  // {
  //   recordId: 46,
  //   teacher: {
  //     name: "Nathan Allen",
  //     id: 10046,
  //     department: "Finance",
  //   },
  //   studentCount: 28,
  //   status: "Active",
  // },
  // {
  //   recordId: 47,
  //   teacher: {
  //     name: "Evelyn Young",
  //     id: 10047,
  //     department: "Engineer",
  //   },
  //   studentCount: 16,
  //   status: "Suspended",
  // },
  // {
  //   recordId: 48,
  //   teacher: {
  //     name: "Zoe Hernandez",
  //     id: 10048,
  //     department: "Arts",
  //   },
  //   studentCount: 22,
  //   status: "Blocked",
  // },
  // {
  //   recordId: 49,
  //   teacher: {
  //     name: "Isaac King",
  //     id: 10049,
  //     department: "Finance",
  //   },
  //   studentCount: 27,
  //   status: "Active",
  // },
  
  // {
  //   recordId: 50,
  //   teacher: {
  //     name: "Clara Wright",
  //     id: 10050,
  //     department: "Engineer",
  //   },
  //   studentCount: 18,
  //   status: "Inactive",
  // },
];
